import { Radio as AntdRadio } from 'antd'

export const Radio = AntdRadio
